'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import moment from 'moment'
import React from 'react'

// walrus
import Text from '@components/kit/text'
import Box from '@components/kit/box'
import PollAnswerTile from './poll-answer-tile'
import {
  PollActivity as PollAnswer,
  PollActivityAnswer as Answer
} from '@store/User/types'
import uuidHex from '@utils/uuid-hex'

/* -----------------------------------------------------------------------------
 * LabeledPollAnswer
 * -------------------------------------------------------------------------- */

const LabeledPollAnswers = ({ answers }) => {
  return (
    <Box>
      {answers.map(answer => (
        <Box flexDirection='column' justifyContent='center' key={answer.key}>
          {answer.row.map(answer =>
            answer.selected ? (
              <Box
                key={answer.answer_id}
                bg='white'
                width='100%'
                borderRadius='medium'
                boxShadow='medium'
                justifyContent='center'
                alignItems='center'
                p='12'
                mt='08'
              >
                <Text textColor='green' fontWeight='700'>
                  {answer.label}
                </Text>
              </Box>
            ) : null
          )}
        </Box>
      ))}
    </Box>
  )
}

/* -----------------------------------------------------------------------------
 * AdcHocPollAnswer
 * -------------------------------------------------------------------------- */

export type AdcHocPollAnswerProps = {
  poll: PollAnswer
}

const AdcHocPollAnswer = ({ poll }: AdcHocPollAnswerProps) => {
  // an activity can come back with no questions at all, and mapping over that
  // took the whole chat route down
  const questions = poll.event_data.questions ?? []
  const questionsCount = questions.length

  const labeledAnswers = q =>
    q.map(answerRow => ({
      key: uuidHex(),
      row: answerRow
    }))

  return (
    <Box
      width='100%'
      mt='16'
      bg='white'
      flexDirection='column'
      alignItems='center'
    >
      <Text fontSize={10} fontWeight={700} textColor='shade04'>
        {moment(poll.timestamp).format('MMM DD, YYYY')}
      </Text>

      {questions.map((question, questionIndex) => (
        <PollAnswerTile
          key={question.question_id}
          width='100%'
          mt='16'
          themeVariant='lightGreen'
          title='Poll Answer'
          titleRight={
            questionsCount > 1
              ? `${questionIndex + 1} of ${questionsCount}`
              : ''
          }
        >
          <Text textColor='everestGreen' mb='12'>
            {question.question}
          </Text>

          <LabeledPollAnswers answers={labeledAnswers(question.answers)} />
        </PollAnswerTile>
      ))}
    </Box>
  )
}

export default AdcHocPollAnswer
